import React, { useEffect, useState } from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const InvoiceListDetails = () => {
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {


    fetchInvoices();
  }, []);

  const fetchInvoices = async () => {
    try {
      const url = `${API_DOMAIN}${API_ROUTES.invoice}`;
      const token = localStorage.getItem('token');
      
      const response = await axios.get(url, { headers });

      const invoicesWithCustomer = await Promise.all(response.data.map(async (invoice) => {
        const customer = await fetchCustomer(invoice.customer);
        return { ...invoice, customer_name: customer.name };
      }));

      setInvoices(invoicesWithCustomer);
    } catch (error) {
      console.error('Error fetching invoices:', error);
    }
  };

  const fetchCustomer = async (customerId) => {
  try {
    const url = `${API_DOMAIN}${API_ROUTES.customer}${customerId}/`;
    const token = localStorage.getItem('token');
    
    const response = await axios.get(url, { headers });

    return response.data;
  } catch (error) {
    console.error('Error fetching customer:', error);
  }
};

  const columns = [
    { label: 'Invoice Number', value: 'invoice_number' },
    { label: 'Customer', value: 'customer_name' },
    { label: 'Issue Date', value: 'issue_date' },
    { label: 'Due Date', value: 'due_date' },
    { label: 'Total Amount', value: 'total_amount' },
    { label: 'Status', value: 'status' },
    { label: 'Description', value: 'description' },
  ];

  const handleViewDetails = (invoiceId) => {
    //console.log('View Details', invoiceId);
    const encodedId = btoa(invoiceId);
    window.location.href = `/invoice/details/${encodedId}`;
  };

  const actionButtons = [
    { label: 'View Details', handler: handleViewDetails },
  ];

  return <ListTemplate columns={columns} data={invoices} actionButtons={actionButtons} />;
};

export default InvoiceListDetails;